/**
 * 检测任务国际化
 * date：2022 05 10
 */

export default {
  task: {
    CheckSensorBreakdown: '检测传感器连接',
    CheckGatewayBreakdown: '检测网关连接',
    CheckRelayBreakdown: '检测中继连接',
    CheckDisplayBreakdown: '检测显示屏连接',
    zbp_sensor_off: 'ZBP温湿度传感器离线检测',
    zbp_v2_sensor_off: 'ZBP二代传感器离线检测',
    '4g_sensor_off': '4G传感器离线检测',

    lora_sensor_off: 'LORA温湿度传感器离线检测',
    zeta_sensor_off: 'ZETA温湿度传感器离线检测',
    gateway_1_off: '网关1.0离线检测',
    display_1_off: '显示屏1.0离线检测',
    relay_1_off: '中继1.0传感器离线检测',
    task_detection_status_running: '运行',
    task_detection_status_stop: '停止',
    detection_interval_minute: '分钟',
    detection_interval_hour: '小时',
    detection_interval_day: '天'
  }
}
